export default "__VITE_ASSET__4vlca5mR__"